function getPaymentMethodsOptions(operation, countryCode, $t) {
  const methods = {
    payWithWallet: {
      id: 'wallet',
      name: $t('transactions.form.payWithWallet'),
      getPhone: false,
    },
    payWithMomo: {
      id: 'momo',
      name: $t('transactions.form.payWithMobileMoney'),
      getPhone: true,
    },
    payWithNita: {
      id: 'momo',
      name: 'Payer avec Nita',
      getPhone: true,
      wallet: 'NITA',
    },
    payWithAmana: {
      id: 'momo',
      name: 'Payer avec Amana',
      getPhone: true,
      wallet: 'AMANA',
    },
    payWithZeyna: {
      id: 'momo',
      name: 'Payer avec Zeyna',
      getPhone: true,
      wallet: 'ZEYNA',
    },
    getPaidOnWallet: {
      id: 'wallet',
      name: $t('transactions.form.getPaidOnWallet'),
      getPhone: false,
    },
    getPaidOnMobileMoney: {
      id: 'momo',
      name: $t('transactions.form.getPaidOnMobileMoney'),
      getPhone: true,
    },
    getPaidOnNita: {
      id: 'momo',
      name: 'Sur mon compte Nita',
      getPhone: true,
      wallet: 'NITA',
    },
    getPaidOnAmana: {
      id: 'momo',
      name: 'Sur Mon compte Amana',
      getPhone: true,
      wallet: 'AMANA',
    },
    getPaidOnZeyna: {
      id: 'momo',
      name: 'Sur Mon compte Zeyna',
      getPhone: true,
      wallet: 'ZEYNA',
    },
  }
  let options = []

  if (/(funding)|(buy)/i.test(operation)) {
    options = []
    if (countryCode == 'NE')
      options.push(
        methods.payWithNita,
        methods.payWithAmana,
        methods.payWithZeyna,
      )
    options.push(methods.payWithMomo, methods.payWithWallet)
  }

  if (/(withdraw)|(sell)/i.test(operation)) {
    options = []
    if (countryCode == 'NE')
      options.push(
        methods.getPaidOnNita,
        methods.getPaidOnAmana,
        methods.getPaidOnZeyna,
      )
    options.push(methods.getPaidOnMobileMoney, methods.getPaidOnWallet)
  }
  if (/wallet/i.test(operation)) options.splice(1, 1)
  console.log(operation, /wallet/i.test(operation))
  return options
}

export { getPaymentMethodsOptions }
